import {
  getAmountWithCurrency,
  parseNumberByPrecision,
  setTranslationValues,
  useTranslation,
} from '@pascal/pascal-core';
import { amountConverterPipe, toLocaleTimeString } from '../../../../helpers';

const BonusIslandInfoModalWeb = ({
  onClose,
  endDate,
  minBonus,
  maxBonus,
  currencyCode,
  currency,
  startDate,
  minAmount,
  stagesCount,
  displayNames,
  tournamentRanges,
}) => {
  const t = useTranslation();
  const displayNamesCount = displayNames.length;
  const tournamentRangesCount = tournamentRanges.length;

  return (
    <div className='b-i-m-info-popup-wr pop-an'>
      <div className='b-i-info-popup-wr'>
        <div className='b-i-info-popup-t-area'>
          <div className='b-i-info-popup-t-area-ins'>
            <div className='b-i-info-popup-t-area-ins-left'>
              <p className='b-i-pop-title-left'>"{t('BONUS_ISLAND')}"</p>
            </div>
            <div className='b-i-info-popup-t-area-ins-right'>
              <span className='b-i-pop-icon-right' onClick={onClose}>
                <i className='bc-i-close' />
              </span>
            </div>
          </div>
        </div>
        <div className='b-i-info-popup-b-area'>
          <div className='b-i-info-popup-b-area-ins'>
            <div className='scroll-b scrollable-container'>
              <div className='b-i-info-pop-content'>
                <p className='b-inf-text-top'>
                  {setTranslationValues(t('BONUS_INFO_P1'), {
                    minBonus: getAmountWithCurrency({
                      amount: minBonus,
                      currencyCode: currency,
                      currencyToShow: currencyCode,
                    }),
                    maxBonus: getAmountWithCurrency({
                      amount: amountConverterPipe(parseNumberByPrecision(1, maxBonus)),
                      currencyCode: currency,
                      currencyToShow: currencyCode,
                    }),
                    stagesCount,
                  })}
                  <br />
                  {setTranslationValues(t('BONUS_INFO_P1_1'), {
                    displayNamesCount,
                    stagesCount,
                  })}
                  <br />
                  {t('HOW_TO_CLAIM_YOUR_BONUSES')}
                </p>
                <div className='b-i-info-pop-b-con'>
                  <div className='b-inf-text-b-d'>
                    <div className='b-inf-text-b-d-left'>
                      <span className='b-inf-text-b-d-left-sp' />
                    </div>
                    <div className='b-inf-text-b-d-right'>
                      <p className='b-inf-text-bottom'>
                        {setTranslationValues(t('BONUS_INFO_P2'), {
                          minAmount: getAmountWithCurrency({
                            amount: minAmount,
                            currencyCode: currency,
                            currencyToShow: currencyCode,
                          }),
                        })}
                      </p>
                    </div>
                  </div>
                  <div className='b-inf-text-b-d'>
                    <div className='b-inf-text-b-d-left'>
                      <span className='b-inf-text-b-d-left-sp' />
                    </div>
                    <div className='b-inf-text-b-d-right'>
                      <p className='b-inf-text-bottom'>
                        {setTranslationValues(t('BONUS_INFO_P3'), {
                          stagesCount,
                          displayNamesCount,
                        })}
                      </p>
                    </div>
                  </div>
                  <div className='b-inf-text-b-d'>
                    <div className='b-inf-text-b-d-left'>
                      <span className='b-inf-text-b-d-left-sp' />
                    </div>
                    <div className='b-inf-text-b-d-right'>
                      <p className='b-inf-text-bottom'>{t('BONUS_INFO_P4')}</p>
                    </div>
                  </div>
                  <h4 className='bonus-info-section-heading'>{t('GET_THE_BONUS')}</h4>
                  <div className='b-i-info-pop-b-con'>
                    <p className='b-inf-text-sub-header'>{t('WHAT_ARE_THE_OUTCOMES')}</p>
                  </div>
                  <div className='b-inf-text-b-d'>
                    <p className='b-inf-text-top'>{t('BONUS_INFO_P5')}</p>
                  </div>
                  <div className='b-i-info-pop-b-con'>
                    {displayNames.map((displayName, ind) => (
                      <p className='b-inf-text-top' key={displayName}>
                        {ind + 1}. {displayName}
                      </p>
                    ))}
                  </div>
                  <div className='b-inf-text-b-d'>
                    <div className='b-inf-text-b-d-left'>
                      <span className='b-inf-text-b-d-left-sp' />
                    </div>
                    <div className='b-inf-text-b-d-right'>
                      <p className='b-inf-text-bottom'>
                        {setTranslationValues(t('BONUS_INFO_P6'), {
                          displayNamesCount,
                        })}
                      </p>
                    </div>
                  </div>
                  <div className='b-inf-text-b-d'>
                    <div className='b-inf-text-b-d-left'>
                      <span className='b-inf-text-b-d-left-sp' />
                    </div>
                    <div className='b-inf-text-b-d-right'>
                      <p className='b-inf-text-bottom'>
                        {setTranslationValues(t('BONUS_INFO_P7'), {
                          tournamentRangesCount,
                        })}
                      </p>
                    </div>
                  </div>
                  {tournamentRanges.map((range) => (
                    <div className='b-inf-text-b-d left-margin' key={range.minAmount}>
                      <div className='b-inf-text-b-d-left'>
                        <span className='b-inf-text-b-d-left-sp' />
                      </div>
                      <div className='b-inf-text-b-d-right'>
                        <p className='b-inf-text-bottom'>
                          {`${getAmountWithCurrency({
                            amount: range.minAmount,
                            currencyCode: currency,
                            currencyToShow: currencyCode,
                          })} - ${getAmountWithCurrency({
                            amount: range.maxAmount,
                            currencyCode: currency,
                            currencyToShow: currencyCode,
                          })}`}
                        </p>
                      </div>
                    </div>
                  ))}
                  <div className='b-inf-text-b-d'>
                    <div className='b-inf-text-b-d-left'>
                      <span className='b-inf-text-b-d-left-sp' />
                    </div>
                    <div className='b-inf-text-b-d-right'>
                      <p className='b-inf-text-bottom'>{t('BONUS_INFO_P8')}</p>
                    </div>
                  </div>
                  <div className='b-inf-text-b-d'>
                    <div className='b-inf-text-b-d-left'>
                      <span className='b-inf-text-b-d-left-sp' />
                    </div>
                    <div className='b-inf-text-b-d-right'>
                      <p className='b-inf-text-bottom'>{t('BONUS_INFO_P9')}</p>
                    </div>
                  </div>
                  <h4 className='bonus-info-section-heading'>{t('TERMS_AND_CONDITIONS')}</h4>
                  <p className='b-inf-text-top'>
                    1.
                    {setTranslationValues(t('BONUS_INFO_P10'), {
                      endDate: toLocaleTimeString(endDate),
                      startDate: toLocaleTimeString(startDate),
                    })}
                  </p>
                  <p className='b-inf-text-top'>2. {t('BONUS_INFO_P11')}</p>
                  <p className='b-inf-text-top'>3. {t('BONUS_INFO_P12')}</p>
                  <p className='b-inf-text-top'>4. {t('BONUS_INFO_P13')}</p>
                  <p className='b-inf-text-top'>5. {t('BONUS_INFO_P14')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BonusIslandInfoModalWeb;
